import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

const messages = defineMessages({
  alertParameterInsertOptionsStoreName: {
    description: 'Automation Rules Create Alert order parameter insert options - Store Name',
    defaultMessage: 'Store Name - [Store Name]',
    id: 'TQuS6Z',
  },
  alertParameterInsertOptionsRecipientName: {
    description: 'Automation Rules Create Alert order parameter insert options - Recipient Name',
    defaultMessage: 'Recipient Name - [Recipient Name]',
    id: 'Kgag8u',
  },
  alertParameterInsertOptionsOrderDate: {
    description: 'Automation Rules Create Alert order parameter insert options - Order Date',
    defaultMessage: 'Order Date - [Order Date]',
    id: 'kkJ52Y',
  },
  alertParameterInsertOptionsOrderNumber: {
    description: 'Automation Rules Create Alert order parameter insert options - Order Number',
    defaultMessage: 'Order # - [Order #]',
    id: 'r1DmK5',
  },
});

export default [
  {
    displayName: <FormattedMessage {...messages.alertParameterInsertOptionsStoreName} />,
    parameter: '[Store Name]',
  },
  {
    displayName: <FormattedMessage {...messages.alertParameterInsertOptionsRecipientName} />,
    parameter: '[Recipient Name]',
  },
  {
    displayName: <FormattedMessage {...messages.alertParameterInsertOptionsOrderDate} />,
    parameter: '[Order Date]',
  },
  {
    displayName: <FormattedMessage {...messages.alertParameterInsertOptionsOrderNumber} />,
    parameter: '[Order #]',
  },
];
